import React, { Fragment, useState } from "react";
import { useForm } from "react-hook-form";
import { Row, Col, Form, Label, FormGroup, Button, Input, Card, CardBody, CardFooter, CardHeader } from "reactstrap";
import RequiredField, { FirstName, LastName, Submit, Cancel,BirthDate, Age,MobileNo,AadharNumber, Gender,Address, Department, Password, ConfirmPassword} from "../../../../Constant";
import { Breadcrumbs, H5 } from "../../../../AbstractElements";
import { useNavigate } from "react-router";


const BranchForm = ({ setSteps }) => {
  const navigate = useNavigate()

  const [formdata, setFormdata] = useState({});
  const [view, setView] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => {
    setFormdata((prev) => ({ ...prev, ...data }));
    setSteps((prev) => prev + 1);
  };


  return (
    <Fragment>
      <Breadcrumbs parent="Branch" mainTitle="Branch Form" title="Branch Form" />
          <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
      <Row className={!view? "justify-content-center" : "justify-content-center"}>
      {!view &&   <Col sm="6"  className="m-0 p-0">
            <Card className="border-0">
                <CardHeader className="text-white bg-dark"><H5>Branch Details</H5></CardHeader>
            <CardBody>
            <FormGroup className="mb-3">
              <Label htmlFor="fname">{"Branch Name"} <RequiredField/></Label>
              <input className={`form-control ${errors.branchname && "is-invalid"}`} id="branchname" type="text" name="branchname" defaultValue={formdata.branchname || ""} {...register("branchname", { required: true })} />
              <span className="text-danger">{errors.branchname && "Branch name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="contactnumber">{'Branch Contact Number'} <RequiredField/></Label>
              <input className={`form-control ${errors.contactnumber && "is-invalid"}`} id="contactnumber" type="text" name="contactnumber" defaultValue={formdata.contactnumber || ""} {...register("contactnumber", { required: true })} />
              <span className="text-danger">{errors.contactnumber && "Contact number is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="lname">{"Address(Door no. & Street name)"} <RequiredField/></Label>
              <input className={`form-control ${errors.address && "is-invalid"}`} id="address" type="text" name="address" defaultValue={formdata.address || ""} {...register("address", { required: true })} />
              <span className="text-danger">{errors.address && "Address is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="town">{'Town'} <RequiredField/></Label>
              <input className={`form-control ${errors.town && "is-invalid"}`} id="town" type="text" name="town" defaultValue={formdata.town || ""} {...register("town", { required: true })} />
              <span className="text-danger">{errors.town && "Town is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="city">{"City"}<RequiredField/></Label>
              <input className={`form-control ${errors.city && "is-invalid"}`} id="city" type="text" name="city" defaultValue={formdata.city || ""} {...register("city", { required: true })} />
              <span className="text-danger">{errors.city && "City is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="state">{"State"}<RequiredField/></Label>
              <input className={`form-control ${errors.state && "is-invalid"}`} id="state" type="text" name="state" defaultValue={formdata.state || ""} {...register("state", { required: true })} />
              <span className="text-danger">{errors.state && "State is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="zipcode">{"Zip Code"}<RequiredField/></Label>
              <input className={`form-control ${errors.zipcode && "is-invalid"}`} id="zipcode" type="text" name="zipcode" pattern={[0-9]} defaultValue={formdata.zipcode || ""} {...register("zipcode", { required: true })} />
              <span className="text-danger">{errors.zipcode && "Zipcode is required"}</span>
            </FormGroup>
            <CardFooter className="text-end  p-0">
            <Button className="success" color="success" onClick={()=> setView(!view)}>
                {"Next"}
              </Button>
            </CardFooter>
                                
                                </CardBody>
            </Card>
            </Col>
            }
            {view && <Col sm="6" >
            <Card>
            <CardHeader className="text-white bg-dark"><H5>Admin Details</H5></CardHeader>
            <CardBody>
            <FormGroup className="mb-3">
              {/* <Label htmlFor="name">Admin Name</Label> */}
              <Label htmlFor="name">First Name <RequiredField/></Label>
              <input className={`form-control ${errors.firstname && "is-invalid"}`} id="firstname" type="text" name="firstname" defaultValue={formdata.firstname || ""} {...register("firstname", { required: false })} />
              <span className="text-danger">{errors.firstname && "First name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="lastname">{"Last Name"} <RequiredField/></Label>
              <input className={`form-control ${errors.lastname && "is-invalid"}`} id="lastname" type="text" name="lastname" defaultValue={formdata.lastname || ""} {...register("lastname", { required: false })} />
              <span className="text-danger">{errors.lastname && "last name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="mobilenumber">{'Mobile Number'} <RequiredField/></Label>
              <input className={`form-control ${errors.mobilenumber && "is-invalid"}`} id="mobilenumber" type="number" name="mobilenumber"  defaultValue={formdata.mobilenumber || ""} {...register("contactnumber", { required: false })} />
              <span className="text-danger">{errors.mobilenumber && "mobilenumber is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="password">{Password} <RequiredField/></Label>
              <input className={`form-control ${errors.password && "is-invalid"}`} id="password" type="password" name="password" defaultValue={formdata.password || ""} {...register("password", { required: false })} />
              <span className="text-danger">{errors.password && "password Name is required"}</span>
            </FormGroup>
            <FormGroup className="mb-3">
              <Label htmlFor="relation">{ConfirmPassword} <RequiredField/></Label>
              <input className={`form-control ${errors.confirmpassword && "is-invalid"}`} id="confirmpassword" type="password" name="confirmpassword" defaultValue={formdata.confirmpassword || ""} {...register("confirmpassword", { required: false })} />
              <span className="text-danger">{errors.confirmpassword && "Confirm password is required"}</span>
            </FormGroup>
            </CardBody>
            <CardFooter className="text-end ">
              <Button className="secondary me-2" onClick={()=> navigate(`${process.env.PUBLIC_URL}/settings/managebranch/:layout>}`)}>
                {Cancel}
              </Button>
            <Button className="primary" type="submit">
                {Submit}
              </Button>
            </CardFooter>
        </Card>
        </Col>
            }
            
      </Row>
          </Form>
    </Fragment>
  );
};

export default BranchForm;
